import { Theme } from '@mui/material';

export const sxStyles = {
  infographicItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '40px',
  },
  infographicTitle: {
    marginBottom: '0.25rem',
  },
  itemValueContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  itemValue: (theme: Theme) => ({
    marginLeft: '0.25rem',
    textTransform: 'capitalize',
    color: theme.palette.grey['600'],
  }),
};
